import { createSlice } from "@reduxjs/toolkit";
import {
  fetchTeam,
  fetchTeamsById,
  updateStatusInTeam,
  updateTeam,
  fetchAllDropdowns,
  exportOTeamsCSV,
  fetchAllDropdownsTeams,
} from "./thunk";

interface TeamsState {
  teamList: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
  selectedOrganisation: any;
  exportCSVLoading: boolean;
  exportCSVError: string | null;
  orgDropDown: any[];
  departmentDropDown: any[];
  orgCityDropDown: any[];
  teamsDropDown: any[];

  dropdownOptions: Record<string, any[]>;
}

const initialState: TeamsState = {
  teamList: [],
  rowCount: 0,
  loading: false,
  error: null,
  selectedOrganisation: null,
  exportCSVLoading: false,
  exportCSVError: null,
  dropdownOptions: {},
  orgDropDown: [],
  departmentDropDown: [],
  orgCityDropDown: [],
  teamsDropDown: [],
};

const teamSlice = createSlice({
  name: "teams",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch All Teams
      .addCase(fetchTeam.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTeam.fulfilled, (state, action) => {
        state.loading = false;
        state.teamList = Array.isArray(action.payload.data)
          ? action.payload.data
          : [];
        state.rowCount =
          typeof action.payload.rowCount === "number"
            ? action.payload.rowCount
            : 0;
      })
      .addCase(fetchTeam.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch teams";
      })

      // Fetch Single Team by ID
      .addCase(fetchTeamsById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedOrganisation = action.payload;
      })
      .addCase(fetchTeamsById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Update Team
      .addCase(updateTeam.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.teamList = state.teamList.map((org: any) =>
          org.id === action.payload.id ? action.payload : org
        );
      })
      .addCase(updateTeam.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update team";
      })

      // Update Status
      .addCase(updateStatusInTeam.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.teamList = state.teamList.map((org: any) =>
          org.id === action.payload.id ? action.payload : org
        );
      })
      .addCase(updateStatusInTeam.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update team status";
      })
      .addCase(exportOTeamsCSV.pending, (state) => {
        state.exportCSVLoading = true;
        state.exportCSVError = null;
      })
      .addCase(exportOTeamsCSV.fulfilled, (state) => {
        state.exportCSVLoading = false;
        state.exportCSVError = null;
      })
      .addCase(exportOTeamsCSV.rejected, (state, action) => {
        state.exportCSVLoading = false;
        state.exportCSVError =
          typeof action.payload === "string"
            ? action.payload
            : action.error.message || "Failed to export CSV";

      }) 
    .addCase(fetchAllDropdownsTeams.fulfilled, (state, action) => {
  state.orgDropDown = action.payload.orgDropDown || [];
  state.departmentDropDown = action.payload.departmentDropDown || [];
  state.teamsDropDown = action.payload.teamsDropDown || [];
})
  },
});

export default teamSlice.reducer;
